module.exports = __webpack_public_path__ + "static/media/LogoEJECfundoroxo1.56801c06.png";